import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
import { checkoutUrl } from '../data/checkout';
export function FloatingCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById('first-cta');
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-123" data-mp="2atgy0fc8s03v">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white/95 px-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] pt-3 backdrop-blur" data-id="element-124" data-mp="38b8o0974qqph">
          <a href={checkoutUrl} className="animate-cta-shake mx-auto flex w-full max-w-xl items-center justify-center gap-2.5 rounded-2xl bg-cta px-4 py-4 text-[16px] font-extrabold uppercase tracking-wide text-white shadow-cta hover:bg-cta-dark sm:text-lg" data-id="element-125" data-mp="2pcea7sy0n1np">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-126" data-mp="2kd1pbdqpg4nr" />
            <span className="whitespace-nowrap" data-id="element-127" data-mp="2kayorzrxet4s">Get it now · Only $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}